import styled from 'styled-components';
import GradientBanner from '../../resources/imgs/degrade-background.png';
import BannerImage3 from '../../resources/imgs/banner-image3cap.png';
import { Icon } from 'semantic-ui-react';

export const Container = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  border-radius: 4px;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: row;
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
    gap: 10px;
  }
`;

export const InfoBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media (max-width: 768px) {
    gap: 20px;
  }

  @media (max-width: 480px) {
    gap: 15px;
  }
`;

export const AppLabel = styled.label`
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  color: ${props => props.theme.main.color};

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const AppsContainer = styled.label`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const AppCard = styled.a`
  position: relative;
  display: flex;
  flex-direction: row;
  border: 1px solid #dddddd;
  border-radius: 6px;
  align-items: center;
  justify-content: start;
  width: 100%;
  min-height: 68px;
  padding: 4px 20px 5px 5px;
  gap: 10px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  span {
    color: #808080;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;

    @media (max-width: 480px) {
      font-size: 13px;
    }
  }

  @media (max-width: 768px) {
    min-height: 60px;
    padding: 8px 15px 8px 8px;
  }

  @media (max-width: 480px) {
    min-height: 56px;
  }
`;

export const IconRight = styled(Icon)`
  position: absolute;
  right: 5px;

  @media (max-width: 768px) {
    right: 8px;
  }
`;

export const WelcomeTitle = styled.span`
  color: ${props => props.theme.main.color};
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;

  b {
    font-size: 38px;
    line-height: 51px;
    margin-top: -10px;

    @media (max-width: 768px) {
      font-size: 28px;
      line-height: 38px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
      line-height: 32px;
    }
  }

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 24px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const WelcomeSubtitle = styled.span`
  font-size: 14px;
  line-height: 19px;
  text-align: left;
  color: #808080;

  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 18px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  align-items: stretch;
  gap: 15px;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px solid ${props => props.theme.main.color};
  padding-bottom: 5px;
  gap: 10px;
  align-items: center;

  h2 {
    font-size: 28px;
    font-weight: 800;
    color: ${props => props.theme.main.color};

    @media (max-width: 768px) {
      font-size: 22px;
    }

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 10px;
  }
`;

export const ButtonsWrapper = styled.div<{
  align?: 'between' | 'no-align';
}>`
  display: flex;
  justify-content: ${props => (props.align === 'between' ? 'space-between' : 'start')};
  gap: 10px;
  @media (max-width: 768px) {
    width: 100%;
    button {
      display: flex;
      flex: 1;
      text-align: center;
      margin: 0px !important; // To override the lib style
    }
  }
`;

export const BannersWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  @media (max-width: 768px) {
    gap: 15px;
  }

  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const Banner = styled.div`
  flex: 1;
  height: 288px;
  border-radius: 16px;
  display: grid;
  grid-template-columns: 7fr 5fr;
  overflow: hidden;

  @media (max-width: 1024px) {
    height: 240px;
  }

  @media (max-width: 768px) {
    height: auto;
    min-height: 200px;
    grid-template-columns: 1fr;
  }

  @media (max-width: 480px) {
    min-height: 180px;
    border-radius: 12px;
  }
`;

export const GradientImage = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  background-image: url(${GradientBanner});
  background-size: contain;
  background-repeat: no-repeat;

  ::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to left, rgba(255, 255, 255, 0), 10% #1cb9df);
  }

  @media (max-width: 768px) {
    background-size: cover;
    background-position: center;
  }
`;

export const GradientImageBanner2 = styled.div`
  position: relative;
  background-image: url(${BannerImage3});
  background-size: cover;
  background-position: center;

  ::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      to right,
      rgba(52, 152, 219, 1),
      rgba(20, 60, 87, 0)
    );
  }

  @media (max-width: 768px) {
    background-position: center center;
  }
`;

export const CapitalizeContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 82%;
  height: 100%;
  padding: 36px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  z-index: 1;
  background-color: transparent;

  @media (max-width: 1024px) {
    padding: 24px;
    width: 85%;
  }

  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    padding: 20px;
    justify-content: center;
    gap: 15px;
  }

  @media (max-width: 480px) {
    padding: 15px;
    gap: 12px;
  }
`;

export const CapitalizeText = styled.span`
  font-size: 26px;
  color: #ffffff;
  padding-right: 180px;
  line-height: 26px;

  @media (max-width: 1024px) {
    font-size: 22px;
    line-height: 24px;
    padding-right: 100px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 22px;
    padding-right: 0;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export const CapitalizeButton = styled.button`
  padding: 16px;
  background-color: #ffffff;
  color: #3498db;
  border: 0;
  border-radius: 5px;
  font-size: 14px;
  letter-spacing: 0.02em;
  width: 152px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 44px; /* Touch target adequado */

  &:hover {
    background-color: #f0f0f0;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 200px;
    padding: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 12px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 10px 24px;
  justify-content: center;
  gap: 5px;
  height: 288px;

  h3 {
    font-weight: 800;
    font-size: 24px;
    color: #2b313c;
    z-index: 3;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 20px;
    }

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  span {
    background-color: #e69e0d;
    padding: 12px 24px;
    text-align: center;
    font-size: 22px;
    font-weight: 800;
    z-index: 3;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 18px;
      padding: 10px 20px;
    }

    @media (max-width: 480px) {
      font-size: 16px;
      padding: 8px 16px;
    }
  }

  p {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    z-index: 3;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 14px;
    }

    @media (max-width: 480px) {
      font-size: 13px;
    }
  }

  a {
    color: #ffffff;
    background-color: #2b313c;
    padding: 8px 6px;
    border-radius: 4px;
    z-index: 3;
    font-size: 24px;
    margin-top: 10px;
    min-height: 44px; /* Touch target adequado */
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
      font-size: 20px;
      padding: 10px 8px;
    }

    @media (max-width: 480px) {
      font-size: 18px;
      padding: 8px 6px;
    }
  }

  .building-background-image {
    position: absolute;
    height: auto;
    width: 100%;
    z-index: 2;
    top: 10px;

    @media (max-width: 768px) {
      width: 120%;
      top: 5px;
    }
  }

  .logo {
    width: 100px;
    height: auto;
    margin-top: 10px;

    @media (max-width: 768px) {
      width: 80px;
    }

    @media (max-width: 480px) {
      width: 70px;
    }
  }

  @media (max-width: 1024px) {
    height: 240px;
    padding: 10px 20px;
  }

  @media (max-width: 768px) {
    height: auto;
    min-height: 180px;
    padding: 15px;
  }

  @media (max-width: 480px) {
    min-height: 160px;
    padding: 12px;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  .laptop-image {
    width: 420px;
    height: auto;
    position: absolute;
    top: -10px;
    left: 10px;
    z-index: 3;

    @media (max-width: 1024px) {
      width: 350px;
    }

    @media (max-width: 768px) {
      display: none; /* Oculta imagem complexa em mobile */
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
